export default "__VITE_ASSET__BtkIBUJp__"